// eslint-disable-next-line import/no-extraneous-dependencies
import { FuroDataCheckboxInput } from '@furo/data-input/src/furo-data-checkbox-input';

export class FormBool extends FuroDataCheckboxInput {}

window.customElements.define('form-bool', FormBool);
